var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.serviceComponent)?_c(_vm.serviceComponent,_vm._b({tag:"component"},'component',_vm.listProps,false)):_c('AuditDetails',_vm._b({},'AuditDetails',_vm.listProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }